
import {emptyViewData, emptyViewState} from './emptyStateMethods'
import {getQuestionTemplates} from './questionTemplates'

const resetState = () => {
 return {
   
   officialLanguagePacks: [],
   validLoggedInLoaded: false,
   isMulti: false,
   showcaseOperationInProgress: false, //we dont want to have multiple updates executing at once
   currentMultiLocationI: false,
   multiLocations: [],
   showChangeLocation: false,
   allEntitiesLoaded: false, // this is used for both multi and single
   logoURL: false, //this is a co branded dashbboard
   brandHex: false, //this is a co branded dashbboard   
   loggedInUser: {
     authID: '',
     firstName: '',
     lastName: '',
     contactNumber: {},
     emailAddress: '',
     lastAccessed: false //BEFORE NOW
   },
   viewData: emptyViewData(),
   viewState: emptyViewState(),
   questionTemplates: getQuestionTemplates(),
   pricing: {
      videos: 14,
      videom: 59,
      videol: 139
   },
   planFeatures: {
     learn: {
       base: [
         'Max 200 responses',
         '500 email invites/month',
         '50 Starting text (SMS) credits',
         '2 Social Proof widgets',
         '1,000 widget pageviews',
         '6 Profesionally translated languages'
       ],
       extra: []
     },
     engage: {
       base: [
          'Unlimited responses',
          'Up to 5 sub-locations',
          '5,000 email invites/month',
          '1000 Starting text (SMS) credits',
          'Import online reviews',
          'Automatically send review/feedback invites (integrations)',
          '10 Social Proof widgets',
          'Unlimited widget pageviews',
          '6 Profesionally translated languages'
       ],
       extra: [
         'Invite collaborators',
         'No Feedback Link logo',
         'Custom domain'
       ]
     },
     soar: {
      base: [
        'Unlimited responses',
        'Up to 30 sub-locations',
        '100,000 email invites/month',
        '10,000 Starting text (SMS) credits',
        'Import online reviews',
        'Automatically send review/feedback invites (integrations)',
        '10 Social Proof widgets',
        'Unlimited widget pageviews',
        '6 Profesionally translated languages'
     ],
     extra: [
       'Invite collaborators',
       'No Feedback Link logo',
       'Custom domain'
     ]
     },
     streamline: {
       base: [

       ],
       extra: [

       ]
     }
   }
 }
}

export default resetState
